const SpeakerActionTypes = {
	SET_SHOW_VIDEOS: "SPEAKER_SET_SHOW_VIDEOS",
	SET_SPEAKERS: "SPEAKER_SET_SPEAKERS",
	LOADING_SPEAKER: "LOADING_SPEAKER",
	CLEAR_SPEAKER_DATE: "CLEAR_SPEAKER_DATE",
	TOTAL_SPEAKER_ITEM: "TOTAL_SPEAKER_ITEM"
};

export default SpeakerActionTypes;
